"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
}), Object.defineProperty(exports, "emptyUser", {
    enumerable: !0,
    get: function() {
        return emptyUser;
    }
});
const _common = require("@getstep/proto/common");
function emptyUser() {
    return {
        autoBilling: !1,
        id: '',
        kycStatus: _common.KycStatus.UNKNOWN
    };
}

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9odHRwL21vZGVscy9Vc2VyLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEt5Y1N0YXR1cyB9IGZyb20gJ0BnZXRzdGVwL3Byb3RvL2NvbW1vbidcbmltcG9ydCB0eXBlIHsgVXNlciB9IGZyb20gJ0BnZXRzdGVwL3Byb3RvL3VzZXInXG5cbmV4cG9ydCBmdW5jdGlvbiBlbXB0eVVzZXIoKTogVXNlciB7XG4gICAgcmV0dXJuIHtcbiAgICAgICAgYXV0b0JpbGxpbmc6IGZhbHNlLFxuICAgICAgICBpZDogJycsXG4gICAgICAgIGt5Y1N0YXR1czogS3ljU3RhdHVzLlVOS05PV04sXG4gICAgfVxufVxuIl0sIm5hbWVzIjpbImVtcHR5VXNlciIsImF1dG9CaWxsaW5nIiwiaWQiLCJreWNTdGF0dXMiLCJLeWNTdGF0dXMiLCJVTktOT1dOIl0sIm1hcHBpbmdzIjoiOzs7bUNBR2dCQTs7O2VBQUFBOzs7d0JBSFU7QUFHbkIsU0FBU0E7SUFDWixPQUFPO1FBQ0hDLGFBQWEsQ0FBQTtRQUNiQyxJQUFJO1FBQ0pDLFdBQVdDLGlCQUFTLENBQUNDLE9BQU87SUFDaEM7QUFDSiJ9